import React from 'react';
import './Hero.css';

const Hero = ({ language }) => {
  const translations = {
    en: {
      title: 'SHIP SMARTER. DELIVER FASTER.',
      subtitle: 'Secure integrated transport, reliable prepaid shipments, and comprehensive logistics solutions.',
      exploreServices: 'Explore Services',
      contactUs: 'Contact Us',
    },
    ar: {
      title: 'شحن ذكي. توصيل أسرع',
      subtitle: 'نقل آمن متكامل وشحنات موثوقة مدفوعة مقدمًا وحلول لوجستية شاملة',
      exploreServices: 'استكشف الخدمات',
      contactUs: 'اتصل بنا',
    },
  };

  const t = translations[language];

  return (
    <section className="hero" id="home">
      <div className="hero-container">
        <h2>{t.title}</h2>
        <p>{t.subtitle}</p>
        <div className="hero-buttons">
          <button className="btn-primary">{t.exploreServices}</button>
          <button className="btn-secondary">{t.contactUs}</button>
        </div>
        <div className="hero-graphic">🏍️ 🚗</div>
      </div>
    </section>
  );
};

export default Hero;
